import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import StripeProvider from '@components/Stripe/StripeProvider';
import { setCustomAlert } from '@redux/actions/general';
import { addPaymentMethod } from '@redux/services/paymentMethod';
import { useDispatch } from 'react-redux';
import AddOnPayment from './add.on.payment';
import PaymentFailed from './payment.failed/payment.failed';
import PaymentSuccess from './payment.success/payment.success';
import UserRemoved from './user.removed';

export default function UpdateSeat({
  user,
  paymentMethods,
  addOnSeatsCount,
  availableSeat,
  localLoadingState,
  setLocalLoadingState,
  handleAddMemberModalOpen,
  setUpdateSeatModal,
  selectedTeam,
  setHelperState,
  helperState,
  noOfSeats,
}) {
  const [active, setActive] = useState(1);
  const [showPaymentMethod, setShowPaymentMethod] = useState(false);
  const [defaultCard, setDefaultCard] = useState(null);
  const [newCard, setNewCard] = useState(null);
  useEffect(() => {
    const getDefaultCard = paymentMethods?.find((card) => card?.isDefault);
    setDefaultCard(getDefaultCard);
  }, [paymentMethods]);

  const dispatch = useDispatch();
  const addNewCard = (payment) => {
    if (payment.error) {
      dispatch(
        setCustomAlert({
          message:
            payment?.error?.message ||
            'Something went wrong while adding card!',
          state: true,
          type: 'error',
        })
      );
      setLocalLoadingState(false);
      return;
    }
    if (payment.paymentMethod) {
      dispatch(
        addPaymentMethod(
          {
            paymentMethod: payment.paymentMethod.id,
          },
          paymentMethods
        )
      )
        .catch((err) => {
          dispatch(
            setCustomAlert({
              message:
                err?.message || 'Something went wrong while adding card!',
              state: true,
              type: 'error',
            })
          );
        })
        .then((res) => setNewCard(res.data))
        .finally(() => {
          setShowPaymentMethod(true);
          setActive(1);
          setLocalLoadingState(false);
        });
    }
  };

  return (
    <div className='text-custom-font-color dark:text-white'>
      {active === 1 ? (
        <AddOnPayment
          noOfSeats={noOfSeats}
          selectedTeam={selectedTeam}
          addOnSeatsCount={addOnSeatsCount}
          user={user}
          availableSeat={availableSeat}
          setActive={setActive}
          showPaymentMethod={showPaymentMethod}
          setShowPaymentMethod={setShowPaymentMethod}
          defaultCard={newCard || defaultCard}
          setLoadingState={setLocalLoadingState}
          loadingState={localLoadingState}
          setHelperState={setHelperState}
          helperState={helperState}
        />
      ) : active === 2 ? (
        <PaymentSuccess
          planName={user?.userPlan?.name}
          handleAddMemberModalOpen={handleAddMemberModalOpen}
          setUpdateSeatModal={setUpdateSeatModal}
          selectedTeam={selectedTeam}
        />
      ) : active === 3 ? (
        <PaymentFailed
          setActive={setActive}
          defaultCardID={defaultCard?._id}
          paymentMethods={paymentMethods}
          setShowPaymentMethod={setShowPaymentMethod}
        />
      ) : active === 4 ? (
        <UserRemoved setUpdateSeatModal={setUpdateSeatModal} />
      ) : active === 5 ? (
        <StripeProvider
          dialogAction={{
            defaultBtn: { text: 'Add Card and Pay', width: '70%' },
            customBtn: {
              text: 'Back',
              width: '30%',
              handler: () => setActive(1),
            },
          }}
          handler={addNewCard}
          loading={localLoadingState}
          setLoading={setLocalLoadingState}
        />
      ) : null}
    </div>
  );
}

UpdateSeat.propTypes = {
  user: PropTypes.object,
  selectedTeam: PropTypes.object,
  addOnSeatsCount: PropTypes.bool,
  availableSeat: PropTypes.bool,
  localLoadingState: PropTypes.bool,
  setLocalLoadingState: PropTypes.func,
  paymentMethods: PropTypes.array,
  handleAddMemberModalOpen: PropTypes.func,
  setUpdateSeatModal: PropTypes.func,
  setHelperState: PropTypes.func,
  helperState: PropTypes.object,
  noOfSeats: PropTypes.object,
};
